<template>
    <header class="header" id="page-guest-header">
        <div class="nav header__nav">
            <div class="container">
                <ul class="nav__guest">
                    <li class="alogo"><a href="/" class="logo-wrapper">
                        <!-- div class="logo-snowflake-cover"></div -->
                        <!-- <span class="cap-color-icon-birthday-2019-baloons" style="margin-top: -18px;
    font-size: 80px;"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span><span class="path26"></span><span class="path27"></span><span class="path28"></span><span class="path29"></span><span class="path30"></span><span class="path31"></span><span class="path32"></span><span class="path33"></span><span class="path34"></span><span class="path35"></span><span class="path36"></span><span class="path37"></span><span class="path38"></span><span class="path39"></span><span class="path40"></span><span class="path41"></span><span class="path42"></span><span class="path43"></span><span class="path44"></span><span class="path45"></span><span class="path46"></span><span class="path47"></span><span class="path48"></span><span class="path49"></span><span class="path50"></span><span class="path51"></span><span class="path52"></span></span>
    -->
                        <i class="capitalist-icon-capitalist-logo-headed"></i>
                    </a></li>
                    <li class="sep"></li>
                    <li class=" menu-link "><a href="/business">{{$t('Решения для бизнеса')}}</a></li>
                    <li class=" menu-link "><a href="/individuals">{{$t('Частным лицам')}}</a></li>
                    <li class=" menu-link "><a href="/fees">{{$t('Тарифы')}}</a></li>
                    <li class=" menu-link "><a href="/news">{{$t('Новости')}}</a></li>
                    <li class=" menu-link  _disabled--sel- "><a href="/contacts">{{$t('Контакты')}}</a></li>

                    <li class="menu-lang">
                        <HeaderLangSwitcher/>

                    </li>
                    <li class="sep"></li>
                    <li>
                        <login-button v-slot:default="slotProps">
                          <a href="#" @click.prevent="slotProps.openModal()" class="login-button">
                          <span class="glyphicon glyphicon-user"></span> <span
                            class="login-button-title">{{$t('Войти')}}</span>
                          </a>
                        </login-button>
                        <!-- router-link to="/login" class="login-button">
                            <span class="glyphicon glyphicon-user"></span> <span
                                class="login-button-title">{{$t('Войти')}}</span>
                        </router-link -->
                    </li>

                </ul>

            </div>
        </div>

    </header>
</template>

<script>
import HeaderLangSwitcher from '@/views/layouts/header/HeaderLangSwitcher';
import LoginButton from '@/views/pages/auth/login/LoginButton';

export default {
  name: 'CapGuestHeader',
  components: { LoginButton, HeaderLangSwitcher },
};
</script>

<style scoped>

</style>

<i18n>
    {
        "en": {
            "Войти": "Login",
            "Решения для бизнеса": "Business solutions",
            "Частным лицам": "Individuals",
            "Тарифы": "Fees",
            "Новости": "News",
            "Контакты": "Contacts"
        }
    }
</i18n>
